/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class ChatnotesGrid extends NoboxEntityGrid<ChatnotesRow, any> {
        protected getColumnsKey() { return ChatnotesColumns.columnsKey; }
        protected getDialogType() { return ChatnotesDialog; }
        protected getIdProperty() { return ChatnotesRow.idProperty; }
        protected getInsertPermission() { return ChatnotesRow.insertPermission; }
        protected getLocalTextPrefix() { return ChatnotesRow.localTextPrefix; }
        protected getService() { return ChatnotesService.baseUrl; }
        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var btn = super.getButtons();
            btn.splice(0, 1);
            return btn;
        }
        private _RoomId: number;
        get roomId() {
            return this._RoomId;
        }
        set roomId(value: number) {
            if (this._RoomId !== value) {
                this._RoomId = value;
                this.refresh();
            }
        }
        protected getInitialTitle() {
            return null;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            var equalFilter = {} as ChatnotesRow;
            if (this.roomId != undefined) {
                equalFilter.RoomId = this.roomId;
            }
            request.EqualityFilter = equalFilter;
            return true;
        }
        protected getQuickFilters() {
            var flt = super.getQuickFilters();

            var filter1 = Q.first(flt, x => x.field == ChatnotesRow.Fields.In);
            filter1.handler = h => {
                const request = (h.request as Serenity.ListRequest);
                const start = (h.widget as CustomDateFilter).get_value();
                const end = (h.widget as CustomDateFilter).end_get_value();
                if (h.active) {
                    if (start != null && end != null) {
                        request.Criteria = [[["In"], ">=", start], "and", [["In"], "<=", end]]
                    } else if (start != null) {
                        request.Criteria = [["In"], ">=", start];
                    } else if (end != null) {
                        request.Criteria = [["In"], "<=", end];
                    }
                    h.handled = true;
                } else {
                    request.Criteria = null;
                    h.handled = true;
                }
            };
            return flt;
        }
    }
}